<template>
  <span :class="'tag ' + getOrderStatus().color">
    {{ getOrderStatus().text }}
  </span>
</template>

<script>
import statusesMap from '~/marketplace-front-core/mixin/statusesMap'

export default {
  mixins: [statusesMap],
  props: {
    status: {
      type: String,
      default: null
    }
  },
  methods: {
    getOrderStatus () {
      return this.statusesMap[this.status] || {
        text: this.status,
        color: 'is-light'
      }
    }
  }
}
</script>
